<template>
  <zj-layout-container>
      <div v-for="(item,index) in treeData" :key="index">
        <TreeItem :code="item.code" :activeCode="activeCode" :ref="item.code"></TreeItem>
        <ZjTreeList v-if="item.children&& item.children.length" :treeData="item.children" :activeCode="activeCode" ref="treeList"></ZjTreeList>
      </div>
  </zj-layout-container>
</template>
<script>
import TreeItem from "./TreeItem";
export default {
  name: "ZjTreeList",
  controller: "UI",
  action: "TreeList",
  props: {
    treeData: { type: Array, default: [] },
    activeCode: { type: String, default: '' },
  },
  components: {
    TreeItem
  },
  data() {
    return {
    };
  },
  created: function() {
  },
  methods: {
  }
};
</script>
